import { RestResponse } from "@/business/shared/commons/rest/RestResponse";
import { restClient } from "@/business/shared/commons/rest/restClient";
import { getActualEventUrl } from "../constants/urls";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { EventActions, Event } from "../../domain/events";
import { DaccachErrorActions } from "@/business/shared/commons/DaccachError";

export const getActualEventService = {
  async execute(token: string): Promise<Event | null> {
    const url = getEnvVariable
      .execute("VUE_APP_DACCACH_URL")
      .concat(getActualEventUrl);

    const headers = {
      "web-token": token,
      Accept: "application/json",
    };

    const response: RestResponse = await restClient().sendRequest(
      url,
      "GET",
      null,
      headers
    );

    if (!response.isSuccess) {
      if (response.statusCode == 404) return null;

      const errorMessage =
        response.statusCode == 422
          ? DaccachErrorActions().extractFormError(response.content)
          : response.content;
      throw DaccachErrorActions().createError(errorMessage);
    }

    return EventActions().deserialize(response.content);
  },
};
